<template>
  <div class="h5-page-detail">
    <!-- $a_{2}=y$ -->
    <template v-if="$route.query.type <= 4">
      <!-- 术语 -->
      <div class="doc-main doc-term" v-if="detailData.termChinese">
        <div class="doc-title-text">{{detailData.termChinese}}</div>
        <div class="doc-desc">
          <div class="doc-desc-line" v-if="detailData.termEnglish">
            <span class="doc-desc-left">英文名称：</span>
            <span class="doc-desc-right">{{detailData.termEnglish}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.source">
            <span class="doc-desc-left">来源：</span>
            <span class="doc-desc-right">{{detailData.source}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.classa">
            <span class="doc-desc-left">分类：</span>
            <span class="doc-desc-right">{{detailData.classa}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.department">
            <span class="doc-desc-left">部门：</span>
            <span class="doc-desc-right">{{detailData.department}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.timet">
            <span class="doc-desc-left">实施时间：</span>
            <span class="doc-desc-right">{{detailData.timet | transformTime}}</span>
          </div>
        </div>
        <div class="doc-desc">
          <div class="doc-desc-line" v-if="detailData.timet">
            <span class="doc-desc-left"> 释义：</span>
          </div>
          <div class="doc-explain">
            {{detailData.explain}}
          </div>
        </div>
      </div>
      <!-- <div class="doc-main" v-else>
        <div class="doc-title-text">{{detailData.isQuestion === 0 ? detailData.question : detailData.title}}</div>
        <div class="doc-desc">
          <div class="doc-desc-line">
            <span class="doc-desc-left">分类：</span>
            <span class="doc-desc-right">{{detailData.classa}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.uploadTime">
            <span class="doc-desc-left">发布日期：</span>
            <span class="doc-desc-right">{{detailData.releaseTime}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.implementTime">
            <span class="doc-desc-left">实施日期：</span>
            <span class="doc-desc-right">{{detailData.implementDate}}</span>
          </div>
          <div class="message-on"
            v-if="/^被.*代替$/g.test(detailData.message)">
            {{detailData.message}}</div>
          <div class="message-off"
            v-else-if="detailData.message && (detailData.message.includes('废止') || detailData.message.includes('失效') || /^代替.*/g.test(detailData.message))">
            {{detailData.message}}</div>
        </div>
      </div> -->
      <!-- 问答的回答 -->
      <!-- <div class="doc-answer" v-if="detailData.isQuestion === 0">
        <span class="doc-answer-text">答：</span>
        <span class="doc-answer-text">{{ detailData.answer }}</span>
      </div> -->
      <div class="doc-main" v-else>
        <div class="doc-title-text">{{detailData.question ? detailData.theme : (detailData.title || getUrlName(detailData.url || detailData.presentationUpload))}}</div>
        <div class="doc-desc">
          <div class="doc-desc-line">
            <span class="doc-desc-left">分类：</span>
            <span class="doc-desc-right">{{detailData.classa}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.uploadTime && !detailData.question">
            <span class="doc-desc-left">发布日期：</span>
            <span class="doc-desc-right">{{detailData.releaseTime}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.implementTime && !detailData.question">
            <span class="doc-desc-left">实施日期：</span>
            <span class="doc-desc-right">{{detailData.implementDate}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.messageSource">
            <span class="doc-desc-left">信息来源：</span>
            <span class="doc-desc-right">{{detailData.messageSource}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.answerSource">
            <span class="doc-desc-left">问答来源：</span>
            <span class="doc-desc-right">{{detailData.answerSource}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.questionTime">
            <span class="doc-desc-left">提问时间：</span>
            <span class="doc-desc-right">{{detailData.questionTime | transformTime}}</span>
          </div>
          <div class="doc-desc-line" v-if="detailData.answerTime">
            <span class="doc-desc-left">答复时间：</span>
            <span class="doc-desc-right">{{detailData.answerTime | transformTime}}</span>
          </div>
          <doc-tip v-if="detailData.message" :message="detailData.message"></doc-tip>
        </div>
      </div>
      <div class="doc-answer" v-if="detailData.question">
        <div class="doc-answer-text">提问：</div>
        <!-- <span class="doc-answer-text">{{ detailData.question }}</span> -->
        <span class="doc-answer-text">{{ detailData.question.replace(/；；/g,'\n') }}</span>
      </div>
      <div class="doc-answer" v-if="detailData.question">
        <div class="doc-answer-text">答复：</div>
        <span class="doc-answer-text">{{ detailData.answer.replace(/；；/g,'\n') }}</span>
        <!-- <span class="doc-answer-text">{{ detailData.answer.replace(/\\n/g,'') }}</span> -->
      </div>
      <div class="doc-block">
      </div>
      <div class="doc-action" v-if="!isAsk" @click="beforeOpenFile(detailData.url || detailData.presentationUpload)">
        <span class="doc-open-text">
          查看文件
          <!-- <a target="_blank" :href="detailData.url || detailData.presentationUpload">查看文件</a> -->
        </span>
      </div>
    </template>
    <template v-else>
      <div class="doc-main credict" v-if="$route.query.type == 5">
        <template v-if="$route.query.creditType == 0">
          <div class="doc-title-text">编制单位</div>
          <div class="title">
            <span class="text">{{detailData.unitName}}</span>
            <span class="status status1" :class="{'status-off': detailData.states != '正常公开'}">{{detailData.states}}</span>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              基本信息
            </div>
            <div class="more-detail-des">
              <span class="des-left">注册时间：</span>
              {{detailData.registerTime | transformTime}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">统一社会信用代码：</span>
              {{detailData.creditCode}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">地址：</span>
              <i class="el-icon-location-information">
                {{detailData.home}}
              </i>
            </div>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              环境影响报告书（表）情况
              <span class="more" @click="goDownload">下载APP查看详情</span>
            </div>
            <div class="more-detail-des">
              <div class="des-left">近三年编制环境影响报告书（表）：</div>
              <p>报告书 * {{detailData.reportThree}}本、报告表 * {{detailData.excelThree}}本</p>
            </div>
            <div class="more-detail-des">
              <div class="des-left">经批准的环境影响报告书（表）：</div>
              <p>报告书 * {{detailData.reportApproval}}本、报告表 * {{detailData.excelApproval}}本</p>
            </div>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              编制人员情况
              <span class="more" @click="goDownload">下载APP查看详情</span>
            </div>
            <div class="more-detail-des">
              <span class="des-left">编制人员数量：</span>
              <span>{{detailData.staffTotal}}</span>
            </div>
            <div class="more-detail-des">
              <span class="des-left">具备环评工程师职业资格数量：</span>
              <span>{{detailData.eiaTotal}}</span>
            </div>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              诚信档案
            </div>
            <div class="more-detail-des">
              <span class="des-left">当前记分周期：</span>
              {{detailData.currentScoringCycle}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">失信积分：</span>
              {{detailData.dishonestScore}}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="doc-title-text">编制人员</div>
          <div class="title">
            <span class="text">{{detailData.name}}</span>
            <span class="status1 status" :class="{'status-off': detailData.states != '正常公开'}">{{detailData.states}}</span>
            <span class="status" :class="detailData.type === '环评工程师' ? 'status2' : 'status3'">{{detailData.type}}</span>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              基本信息
            </div>
            <div class="more-detail-des">
              <span class="des-left">注册时间：</span>
              {{detailData.registerTime | transformTime}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">信用编码：</span>
              {{detailData.numbers}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">从业单位：</span>
              {{detailData.unitName}}
            </div>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              环境影响报告书（表）情况
              <span class="more" @click="goDownload">下载APP查看详情</span>
            </div>
            <div class="more-detail-des">
              <div class="des-left">近三年编制环境影响报告书（表）：</div>
              <p>报告书 * {{detailData.reportThree}}本、报告表 * {{detailData.excelThree}}本</p>
            </div>
            <div class="more-detail-des">
              <div class="des-left">经批准的环境影响报告书（表）：</div>
              <p>报告书 * {{detailData.reportApproval}}本、报告表 * {{detailData.excelApproval}}本</p>
            </div>
          </div>
          <div class="more-detail">
            <div class="more-detail-title">
              诚信档案
            </div>
            <div class="more-detail-des">
              <span class="des-left">当前记分周期：</span>
              {{detailData.currentScoringCycle}}
            </div>
            <div class="more-detail-des">
              <span class="des-left">失信积分：</span>
              {{detailData.dishonestScore}}
            </div>
          </div>
        </template>
      </div>
      <div class="doc-main credict" v-else-if="$route.query.type == 6">
        <div class="doc-title-text">化学品库</div>
      </div>
    </template>
    <div class="doc-bottom" v-show="showDownload">
      <div class="close icon-guanbi iconfont" @click="showDownload = false"></div>
      <div class="logo">
        <img src="https://qn.ep-home.com/img-h5logo.jpg" alt="">
      </div>
      <div class="des">
        <p>打开环保小智</p>
        <p>共享更多环保资料</p>
      </div>
      <div class="download" @click="goDownload">立即打开</div>
    </div>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="refreshPage()"></accountCom>
    <nut-dialog
      :visible="showSubsTips"
      title="提示"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <span v-for="(item, index) in subsTips.split('+/b+')" :key="index">
        {{item.split('+b+')[0]}}<b>{{item.split('+b+')[1]}}</b>
      </span>
      <div align="center">
        <el-button type="primary" @click="showSubsTips = false" style="width:100px;height:36px;margin-top: 10px">取消</el-button>
        <el-button type="primary" @click="doGoRead(phone, tmpType)" style="width:100px;height:36px;margin-top: 10px">确定</el-button>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import accountCom from '@/components/account/index'
import api from '../../api/index'
export default {
  data () {
    return {
      showDownload: true,
      detailData: {
        message: ''
      },
      loginDialogShow: false,
      fileId: 0,
      type: '',
      showSubsTips: false,
      subsTips: '',
      phone: '',
      tmpType: ''
    }
  },
  mounted () {
    // const aux = document.createElement('script')
    // aux.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS-MML_HTMLorMML'
    // document.head.appendChild(aux)
    let fileId = this.$route.query.id
    this.fileId = this.$route.query.id
    this.type = this.$route.query.type
    if (this.$route.query.type === '2' && !this.$route.query.id.includes('t')) {
      fileId = fileId + 't'
    }
    if (this.$route.query.type <= 4) {
      api.getFileDetail({
        fileId,
        type: this.$route.query.type
      }).then(res => {
        if (res.code === 200 && res.data) {
          this.detailData = res.data
        }
      })
    } else if (this.$route.query.type <= 5) {
      api.getCreditDetailById({
        numbersCode: this.$route.query.id,
        creditType: this.$route.query.creditType
      }).then(res => {
        if (res && res.code === 200) {
          this.detailData = res.data
        }
      })
    }
  },
  methods: {
    goDownload () {
      this.$router.push('/h5download')
    },
    beforeOpenFile (fileUrl) {
      var tmpType = 0
      if (this.isFile) {
        tmpType = 0
      } else if (this.isReport) {
        tmpType = 1
      } else if (this.isAsk) {
        tmpType = this.detailData.termId ? 3 : 4
      } else if (this.isOther) {
        tmpType = 2
      }
      api.getUserInfo().then(resUI => {
        if (resUI.code === 200) {
          console.log('resUI', resUI)
          // if (Number(resUI.data.sub1)) {
          //   window.open(fileUrl)
          // } else {
          //   var sucMsg = alert('该文件需要订阅后查看，请前往电脑端或手机端进行订阅。')
          //   if (sucMsg) {}
          //   this.$router.push('/h5download')
          // }
          this.phone = resUI.data.phone
          this.tmpType = tmpType
          var sub = this.detailData.sub ? Number(this.detailData.sub) : 0
          if (sub) {
            api.subscription({
              phone: resUI.data.phone,
              fileId: this.fileId,
              type: tmpType
            }).then(res => {
              if (res.data.readable === 0) {
                this.subsTips = res.data.readMessage
                this.showSubsTips = true
              } else if (res.data.readable === 1) {
                this.doGoRead(this.phone, this.tmpType)
              }
            })
          } else {
            this.doGoRead(this.phone, this.tmpType)
          }
        } else {
          console.log(resUI.code)
          this.loginDialogShow = true
        }
      })
    },
    doGoRead (phone, tmpType) {
      console.log('2222')
      this.showSubsTips = false
      api.countDownload({
        phone: phone,
        fileId: this.fileId,
        type: tmpType
      }).then(resA => {
        if (resA.code === 200) {
          // this.$message({
          //   message: resA.message,
          //   type: 'success'
          // })
          var sucMsg = alert(resA.message)
          if (sucMsg) {}
          // window.open(resA.data.url)
          window.location.href = resA.data.url
        }
      })
    },
    refreshPage (val) {
      if (val) {
        window.location.reload()
      }
    },
    getUrlName (url) {
      if (!url) return
      var tmpArr = url.split('/')
      var name = tmpArr[tmpArr.length - 1]
      return name
    }
  },
  filters: {
    transformTime (data) {
      data = data + ''
      if (data[0] !== '1') {
        data = '0' + data
      }
      while (data.length < 13) {
        data = data + '0'
      }
      function add0 (m) { return m < 10 ? '0' + m : m }
      var time = new Date(Number(data))
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      return y + '-' + add0(m) + '-' + add0(d)
    }
  },
  computed: {
    isFile () {
      return this.$route.query.type === '0'
    },
    isReport () {
      return this.$route.query.type === '1'
    },
    isAsk () {
      return this.$route.query.type === '2' || this.$route.query.type === '3'
    },
    isOther () {
      return this.$route.query.type === '4'
    }
  },
  components: {
    accountCom
  }
}
</script>

<style lang="scss">
.h5-page-detail {
  background: #f5f6f7;
  max-width: 680px;
  margin: 0 auto;
  height: 100%;
  .doc-main {
    padding-bottom: 8px;
    background-color: #fff;
    .doc-title-text {
      padding: 14px;
      font-size: 24px;
      text-align: center;
      border-bottom: 1px solid #efefef;
      box-shadow: 0px 2px 8px #efefef;
      margin-bottom: 12px;
      background: #fff;
    }
    &.credict {
      background-color: #f5f6f7;
      padding-bottom: 88px;
    }
  }
  .doc-term {
    .doc-title-text-en {
      padding: 12px;
    }
    .doc-explain {
      color: #83889a;
      text-indent: 2em;
    }
  }
  .doc-answer {
    background: #fff;
    padding: 12px;
  }
  .doc-action {
    margin-top: 120px;
    bottom: 200px;
    text-align: center;
    width: 100%;
    .doc-open-text  {
      border-radius: 25px;
      background: #007AFF;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      width: 150px;
      box-shadow: 0px 2px 8px #7A7E83;
      a {
        color: #fff;
      }
    }
  }
  .doc-bottom {
    position: fixed;
    // top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    background: #FFF;
    color: #83889a;
    border-top: 1px solid #efefef;
    .close {
      font-size: 22px;
      // flex: 1 0 auto;
      text-align: center;
    }
    .logo img {
      width: 48px;
      margin: 0 8px;
      display: block;
    }
    .des {
      flex: 1 0 auto;
      max-width: 180px;
    }
    .download {
      background: #ff7e3b;
      color: #fff;
      border-radius: 50px;
      padding: 6px 12px;
      margin-left: 12px;
      line-height: 1;
      cursor: pointer;
    }
  }
  .doc-desc {
    padding: 0 12px;
    position: relative;
    overflow: hidden;
    .message-off {
      position: absolute;
      right: 18px;
      bottom: 22px;
      border: 2px solid #F56C6C;
      padding: 1px 3px;
      color: #F56C6C;
      transform: rotate(30deg);
      font-size: 12px;
      opacity: 0.8;
    }
    .message-on {
      position: absolute;
      right: 18px;
      bottom: 22px;
      border: 2px solid #67C23A;
      padding: 1px 3px;
      color: #67C23A;
      transform: rotate(30deg);
      font-size: 12px;
      opacity: 0.8;
    }
    .doc-desc-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 4px 0;
      line-height: 22px;
      &::before {
        content: '';
        height: 16px;
        width: 4px;
        margin-right: 8px;
        background-color: #007AFF;
        display: inline-block;
        flex: 0 0 auto;
        margin-top: 3px;
      }
      text {
        line-height: 1;
      }
      .doc-desc-left {
        flex: 0 0 auto;
        color: #6D6D72;
      }
      .doc-desc-right {
        color: #3F536E;
        text-align: left;
      }
    }
  }
  .doc-block {
    background: #f4f5f6;
    height: 80px;
  }
  .title {
    background: #fff;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    display: flex;
    .text {
      font-size: 16px;
      font-weight: bold;
    }
    .status {
      flex: 0 0 auto;
      line-height: 1;
      border-radius: 2px;
      font-size: 12px;
      padding:2px 4px;
      margin-left: 12px;
    }
    .status1 {
      color: #399E11;
      border: 1px solid #399E11;
    }
    .status2 {
      color: #203744;
      border: 1px solid #203744;
    }
    .status3 {
      color: #6c848d;
      border: 1px solid #6c848d;
    }
    .status-off {
      color: #83889a;
      border: 1px solid #83889a;
    }
  }
  .more-detail {
    background: #fff;
    .more-detail-title {
      padding: 8px 12px;
      margin-top: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #409EFF;
      border-bottom: 1px solid #efefef;
      .more {
        color: #83889a;
        cursor: pointer;
        margin-left: 12px;
      }
    }
    .more-detail-des {
      padding: 4px 12px;
      .des-left {
        color: #83889a;
      }
      .el-link {
        margin-left: 12px;
      }
    }
    .flex-des {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      margin: 0 12px;
      .des-minddle {
        flex: 1;
      }
    }
  }
}
</style>
